<template>
  <section id="pp-resume" class="pp-section pp-resume">
    <div class="pp-resume__header">
      <h2 class="pp-section__title pp-resume__title">
        <i class="mdi mdi-file-document-outline" aria-hidden="true"></i> Resume
      </h2>
      <div class="pp-resume__toolbar">
        <a
          :href="resumeUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="pp-btn pp-btn--ghost pp-resume__tool"
        >
          <i class="mdi mdi-open-in-new" aria-hidden="true"></i> Open
        </a>
        <a
          :href="resumeUrl"
          download
          class="pp-btn pp-btn--outline pp-resume__tool"
        >
          <i class="mdi mdi-download" aria-hidden="true"></i> Download
        </a>
      </div>
    </div>

    <p class="pp-resume__filename">{{ fileName }}</p>

    <div class="pp-resume__frame-wrap">
      <div v-if="loading" class="pp-resume__loading" aria-live="polite">
        <span class="pp-resume__spinner" aria-hidden="true"></span>
        Loading resume…
      </div>
      <iframe
        :key="viewerSrc"
        :src="viewerSrc"
        class="pp-resume__viewer"
        :title="`Resume: ${fileName}`"
        @load="onLoad"
      ></iframe>
    </div>
  </section>
</template>

<script>
import { getOfficeEmbedUrl } from '@/utils/publicProfile';

export default {
  name: 'PublicProfileResume',
  props: {
    resumeUrl: { type: String, required: true },
    viewerType: {
      type: String,
      required: true,
      validator: (v) => ['pdf', 'word'].includes(v),
    },
    fileName: { type: String, default: 'Resume' },
  },
  data() {
    return {
      loading: true,
      loadTimer: null,
    };
  },
  computed: {
    viewerSrc() {
      if (this.viewerType === 'word') {
        return getOfficeEmbedUrl(this.resumeUrl);
      }
      return `${this.resumeUrl}#view=FitH`;
    },
  },
  beforeDestroy() {
    if (this.loadTimer) clearTimeout(this.loadTimer);
  },
  methods: {
    onLoad() {
      if (this.loadTimer) clearTimeout(this.loadTimer);
      this.loading = false;
    },
  },
  mounted() {
    this.loadTimer = setTimeout(() => {
      if (this.loading) this.loading = false;
    }, 12000);
  },
};
</script>
